<script lang="ts">
      let { children = null } = $props()
</script>

<div class="relative text-2xl md:text-4xl px-5 mb-2 pt-16 z-10">
      <span class="h-full relative inline-flex items-center justify-center">
        {@render children?.()}
        <div class="absolute block h-[280%] min-w-[12em] w-[130%] rotate-3 -z-10">
              <img src="/gafa1.png" alt="gafa" class="w-full h-full" />
        </div>
      </span>
</div>
